import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/common';

const LoginForEyeExam = (props)=>/*#__PURE__*/ React.createElement(Button, swcHelpers.extends({
        className: "login-for-eye-exam"
    }, props))
;

export { LoginForEyeExam };
//# sourceMappingURL=LoginForEyeExam.js.map
